<!-- <div
  class="v4-filter"
  nz-dropdown
  nzTrigger="click"
  [(nzVisible)]="visible"
  [nzDropdownMenu]="menu"
  [nzBackdrop]="false"
>
  <div class="selection" [class.placeholder]="!renderText">
    {{ renderText || placeholder }}
  </div>
</div> -->

<v4-custom-select
  [placeholder]="placeholder"
  [textItem]="renderText"
  [showTextItem]="!!renderText"
  [(visible)]="visible"
>
  <div class="v4-layout-dropdown w-[560px]">
    <div class="v4-filter-list pb-[30px]">
      <div class="v4-filter-item" *ngFor="let opt of listOfConditions; trackBy: trackByValue">
        <div
          class="v4-filter v4-filter-selectable"
          [class.selected]="condition === opt.value"
          (click)="condition = opt.value"
        >
          {{ opt.i18nKey | translate }}
        </div>
      </div>
    </div>
    <div class="v4-option-list pb-[30px]">
      <div class="v4-option-item" *ngFor="let opt of listOfOption; trackBy: trackByValue">
        <div class="v4-option" [class.selected]="selected.has(opt.value)" (click)="onClickItem(opt)">
          {{ opt.label | translate }}
        </div>
      </div>
    </div>
    <div class="flex flex-row items-center justify-between">
      <a class="text-primary" href="javascript:void(0)" (click)="onClickReset()">
        {{ "word.reset" | translate }}
      </a>
      <div>
        <button class="mr-3" nz-button nzSize="large" (click)="onClickCancel()">
          {{ "word.cancel" | translate }}
        </button>
        <button nz-button nzType="primary" nzSize="large" (click)="onClickConfirm()">
          {{ "word.confirm" | translate }}
          <!-- 确定 -->
        </button>
      </div>
    </div>
  </div>
</v4-custom-select>
